import axios from "axios";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { HeaderFooterUtils } from "shared/utils";

const Footer = () => {
	const [footerContent, setFooterContent] = useState("");
	const [isLoaded, setIsLoaded] = useState(false);
	const cssLoaded = useRef(new Set());

	const fetchFooterContent = useCallback(async () => {
		try {
			const { data } = await axios.get(
				process.env.NX_PUBLIC_CENTRAL_FOOTER_URL
			);
			setFooterContent(
				HeaderFooterUtils.rewriteRelativeLinks(data)
			);
		} catch (error) {
			console.error("Failed to fetch footer content", error);
		}
	}, []);

	const fetchFooterStyles = useCallback(async () => {
		try {
			const { data: headHtml } = await axios.get(
				process.env.NX_PUBLIC_CENTRAL_FOOTER_HEAD_URL
			);
			const linkPromises = [];

			headHtml.replace(
				/<link.*?href=["'](https?:\/\/[^"']+)["']/gi,
				(_, linkHref) => {
					if (!cssLoaded.current.has(linkHref)) {
						const linkEl =
							document.createElement(
								"link"
							);
						linkEl.rel = "stylesheet";
						linkEl.href = linkHref;
						document.head.appendChild(
							linkEl
						);
						cssLoaded.current.add(linkHref);
						linkPromises.push(
							new Promise(
								(resolve) =>
									(linkEl.onload =
										resolve)
							)
						);
					}
				}
			);

			await Promise.all(linkPromises);
		} catch (error) {
			console.error("Failed to fetch footer styles", error);
		}
	}, []);

	useEffect(() => {
		Promise.all([fetchFooterContent(), fetchFooterStyles()]).then(
			() => setIsLoaded(true)
		);
	}, [fetchFooterContent, fetchFooterStyles]);

	return isLoaded ? (
		<div
			data-qa="footer-content"
			dangerouslySetInnerHTML={{ __html: footerContent }}
		/>
	) : (
		<div />
	);
};

export default Footer;
